import { createClass as _createClass, classCallCheck as _classCallCheck } from '../_virtual/_rollupPluginBabelHelpers.js';
import { JsonApiRecordDecorator } from './JsonApiRecordDecorator.js';
var JsonApiDataDecorator = /*#__PURE__*/function () {
  function JsonApiDataDecorator(data, store) {
    _classCallCheck(this, JsonApiDataDecorator);
    this.data = data;
    this.store = store;
    this.type = data[0].type; //pretty sure redux-json-api will always give back an array
  }
  return _createClass(JsonApiDataDecorator, [{
    key: "find",
    value: function find(id, includes) {
      var obj = this.data.find(function (obj) {
        return obj.id === id;
      });
      if (obj) {
        return this.fillObject(obj, includes);
      }
    }
  }, {
    key: "where",
    value: function where(predicate, includes) {
      var _this = this;
      var objs = this.data.filter(function (obj) {
        return predicate(Object.assign({}, obj, obj.attributes));
      });
      return objs.map(function (obj) {
        return _this.fillObject(obj, includes);
      });
    }
  }, {
    key: "whereNonIncluded",
    value: function whereNonIncluded(predicate, includes) {
      var _this2 = this;
      var objs = this.data.filter(function (obj) {
        return predicate(Object.assign({}, obj, obj.attributes));
      });
      var nonIncludedObjs = objs.filter(function (obj) {
        return !obj.meta || !obj.meta.included;
      });
      return nonIncludedObjs.map(function (obj) {
        return _this2.fillObject(obj, includes);
      });
    }
  }, {
    key: "all",
    value: function all(includes) {
      var _this3 = this;
      return this.data.map(function (obj) {
        return _this3.fillObject(obj, includes);
      });
    }
  }, {
    key: "allNonIncluded",
    value: function allNonIncluded(includes) {
      var _this4 = this;
      return this.data.filter(function (obj) {
        return !obj.meta || !obj.meta.included;
      }).map(function (obj) {
        return _this4.fillObject(obj, includes);
      });
    }
  }, {
    key: "first",
    value: function first(includes) {
      return this.at(0, includes);
    }
  }, {
    key: "at",
    value: function at(index, includes) {
      return this.fillObject(this.data[index], includes);
    }
  }, {
    key: "last",
    value: function last(includes) {
      return this.fillObject(this.data[this.data.length - 1], includes);
    }
  }, {
    key: "fillObject",
    value: function fillObject(original, includes) {
      var obj = Object.assign(new JsonApiRecordDecorator(), original, original.attributes);
      obj._original = original;
      delete obj.attributes;
      delete obj.meta;
      if (includes) {
        obj = this.fillRelated(obj, includes);
      }
      return obj;
    }
  }, {
    key: "fillRelated",
    value: function fillRelated(obj, includes) {
      var _this5 = this;
      if (!includes) return obj;
      var relations;
      if (includes instanceof Array) {
        relations = includes;
      } else if (typeof includes === 'string') {
        relations = includes.split(',');
      } else {
        relations = Object.keys(includes);
      }
      relations.forEach(function (relation) {
        var _obj$relationships;
        var relationData = (_obj$relationships = obj.relationships) === null || _obj$relationships === void 0 || (_obj$relationships = _obj$relationships[relation]) === null || _obj$relationships === void 0 ? void 0 : _obj$relationships.data;
        if (relationData instanceof Array) {
          obj[relation] = relationData.reduce(function (arr, rel) {
            var _this5$store$rel$type;
            var data = (_this5$store$rel$type = _this5.store[rel.type]) === null || _this5$store$rel$type === void 0 ? void 0 : _this5$store$rel$type.find(rel.id, includes[relation]);
            if (data) arr.push(data);
            return arr;
          }, []);
        } else if (relationData && _this5.store[relationData.type]) {
          obj[relation] = _this5.store[relationData.type].find(relationData.id, includes[relation]);
        }
      });
      delete obj.relationships;
      return obj;
    }
  }]);
}();
export { JsonApiDataDecorator };